'use client';

import { useContext, useEffect, useState } from 'react';
import Form from './side-toc-input-form';
import { createLead } from '@/app/lib/actions';
import { GrClose } from 'react-icons/gr';
import { FaCheckCircle } from 'react-icons/fa';
import { RegionalContext } from '@/app/providers/regionalTextProvider';
import { useTranslations } from 'next-intl';

export default function SidePopUp({
  reportId,
  setIsTocActive,
  setIsPopUpShown,
  CustomName,
  keyword,
}) {
  function handleClose() {
    setIsTocActive(false);
    setIsPopUpShown(true);
  }
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dict = useTranslations('toc_popUp');
  const thank_you = useTranslations('thank_you');

  return (
    <>
      <div className="w-80 fixed right-5 top-32 rounded-2xl form-section-trms hidden lg:block">
        <div className="flex items-start">
          {isSubmitted ? (
            <FaCheckCircle
              size={40}
              className="mx-auto animate-bounce"
              style={{ color: 'green' }}
            />
          ) : (
            <p className="font-medium text-white">
              {/* {dict != {} */}
              {dict('title')}
              {/* : 'Most of our clients seek to customize the reports, how do you want us to tailor yours?'} */}
            </p>
          )}{' '}
          <button className="btn border-0" onClick={handleClose}>
            <GrClose size={20} className="text-black" />
          </button>
        </div>
        {isSubmitted ? (
          <div className="mt-4 mx-auto text-center p-3">
            <div className="mx-auto">
              <span className=" font-semibold text-3xl block text-green-800">
                {thank_you('p1')}
              </span>
              <span className=" mt-3 text-black">{thank_you('p2')}</span>
            </div>
          </div>
        ) : (
          <Form
            formAction={createLead}
            formType={'Customization'}
            reportId={reportId}
            setIsSubmitted={setIsSubmitted}
            CustomName={CustomName}
            keyword={keyword}
          />
        )}
      </div>
    </>
  );
}
